import configSchema from './configSchema';
import ReactComponent from '../MultiWiggleRendering';
import MultiDensityRenderer from './MultiDensityRenderer';
export default function MultiDensityRendererF(pluginManager) {
    pluginManager.addRendererType(() => new MultiDensityRenderer({
        name: 'MultiDensityRenderer',
        ReactComponent,
        configSchema,
        pluginManager,
    }));
}
